import _get from 'lodash/get';
import _has from 'lodash/has';
import _isFunction from 'lodash/isFunction';
import _startCase from 'lodash/startCase';

import {
  COLOR_RULES,
  ENUMS_BY_RULE_NAME,
  SIZE_RULES,
} from './StyleConfigurationTableRow.constants';

export function formatCssRuleName(name, labelMap = {}) {
  const label = _get(labelMap, name);
  if (label) {
    return label;
  }
  return _startCase(name);
}

export function doesAnyRuleApply(rules, name) {
  const lowerCasedName = name.toLowerCase();
  return rules.some((rule) => {
    if (_isFunction(rule)) {
      return rule(lowerCasedName);
    }
    return lowerCasedName.includes(rule);
  });
}

export function isColorRule(name) {
  return doesAnyRuleApply(COLOR_RULES, name);
}

export function isSizeRule(name) {
  return doesAnyRuleApply(SIZE_RULES, name);
}

export function isEnumRule(name) {
  return _has(ENUMS_BY_RULE_NAME, name);
}

export function getEnumOptions(name) {
  if (!isEnumRule(name)) {
    return [];
  }

  return ENUMS_BY_RULE_NAME[name].map((value) => ({
    key: value,
    text: value,
    value,
  }));
}

export function isRawRule(name) {
  return !isColorRule(name) && !isSizeRule(name) && !isEnumRule(name);
}
